import { render, staticRenderFns } from "./transcription-file-settings.vue?vue&type=template&id=3688e2af&scoped=true"
import script from "./transcription-file-settings.vue?vue&type=script&lang=js"
export * from "./transcription-file-settings.vue?vue&type=script&lang=js"
import style0 from "./transcription-file-settings.vue?vue&type=style&index=0&id=3688e2af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3688e2af",
  null
  
)

export default component.exports